import { render, staticRenderFns } from "./SamButton.vue?vue&type=template&id=183d3e5b&scoped=true&shadow"
import script from "./SamButton.vue?vue&type=script&lang=js&shadow"
export * from "./SamButton.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamButton.vue?vue&type=style&index=0&id=183d3e5b&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "183d3e5b",
  null
  ,true
)

export default component.exports